module.exports = __webpack_public_path__ + "static/img/bottom_bg.74940fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/bottom_bg.png
// module id = LRVC
// module chunks = 0